const uuidRe =
  /({|%7B)[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(}|%7D)/;

export function isUuid(str: string) {
  return uuidRe.test(str);
}
